var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.025 170.014C342.576 264.462 266.456 341.474 172.008 342.025C77.5592 342.575 0.547284 266.456 -0.00322142 172.007C-0.553727 77.5588 75.5657 0.546891 170.014 -0.00361451C264.463 -0.55412 341.475 75.5653 342.025 170.014ZM5.915 171.973C6.44645 263.153 80.7933 336.638 171.973 336.107C263.153 335.575 336.638 261.228 336.107 170.048C335.576 78.8683 261.229 5.38315 170.049 5.9146C78.8687 6.44606 5.38354 80.7929 5.915 171.973Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOc);
export default __webpack_public_path__ + "static/media/oc.82be5896be18524b18f09c53cc66d03e.svg";
export { ForwardRef as ReactComponent };